export default __webpack_public_path__ + "static/media/socialite-kraver.5b93b172.svg";